"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XAxis_1 = require("../../../parts/XAxis");
exports.default = XAxis_1.XAxis;
//# sourceMappingURL=XAxis.js.map